function SetupVisibility() {
    $('.dashboardTable tr').each(function (i, row) {
        if ($(row).find('th').length > 0)
            return true;
        var cbxSelected = $(row).find('input[name*="chkbxSelectReport"]:checked');
        var cbxDefault = $(row).find('input[name*="chkbxDefault"]');
        if (cbxSelected.length > 0) {
            $(row).css('color', 'black');
            cbxDefault.prop('disabled', false);
        }
        else {
            $(row).css('color', 'gray');
            cbxDefault.prop('disabled', true);
            cbxDefault.prop('checked', false);
        }
    });
}

function CheckAllReports(id, isReadonly) {
    if (!ValidateCanUpdateCheckBox(id, isReadonly))
        return;
    var tableName = id.id.substring(4, id.id.length);
    var tableLookup = '.dashboardTable[name="' + tableName + '"] tr';

    $(tableLookup).each(function (i, row) {
        var selectCB = $(row).find('input[name*="chkbxSelectReport"]');
        if (selectCB.length > 0)
            selectCB.prop('checked', $(id).prop("checked"));
    });

    sessionStorage.IsFormDirty = true;
    $("#btnSave").prop("disabled", false);
    SetupVisibility();
}

function CheckUnCheckReport(id, isReadonly) {
    if (!ValidateCanUpdateCheckBox(id, isReadonly))
        return;

    var tableName = $(id).closest('.dashboardTable').attr('name');
    var cbHeaderId = '#chk_' + tableName;

    if (id.checked) {
        var allChecked = true;
        var tableLookup = '.dashboardTable[name="' + tableName + '"] tr';
        $(tableLookup).each(function (i, row) {
            var selectCB = $(row).find('input[name*="chkbxSelectReport"]');
            if (selectCB.length > 0)
                allChecked &= selectCB.prop('checked');
        });
        if (allChecked)
            $(cbHeaderId).prop('checked', true);
    }
    else {
        $(cbHeaderId).prop('checked', false);
    }

    sessionStorage.IsFormDirty = true;
    $("#btnSave").prop("disabled", false);
    SetupVisibility();
}

function CheckUnCheckDefault(id, isReadonly) {
    if (!ValidateCanUpdateCheckBox(id, isReadonly))
        return;

    //uncheck all
    var allChecked = true;
    $('.dashboardTable tr').each(function (i, row) {
        var selectCB = $(row).find('input[name*="chkbxDefault"]');
        if (selectCB.length > 0)
            allChecked &= selectCB.prop('checked', false);
    });

    sessionStorage.IsFormDirty = true;
    $("#btnSave").prop("disabled", false);
    id.checked = true;
}

function ValidateCanUpdateCheckBox(id, isReadOnly) {
    if (isReadOnly)
        id.checked = !id.checked;
    return !isReadOnly;
}

function PrepareDataForSave() {
    SetupHiddenControl("SelectedReportIds", "chkbxSelectReport", false);
    SetupHiddenControl("DefaultReportId", "chkbxDefault", true);
}

function SetupHiddenControl(hiddenControlId, checkBoxId, breakOnFirst) {
    var hidden = document.getElementById(hiddenControlId);

    if (hidden) {
        hidden.value = "";
        $('.dashboardTable tr').each(function (i, row) {
            if ($(row).find('th').length > 0)
                return true;
            var lookup = 'input[name*=' + checkBoxId + ']:checked';
            var cbx = $(row).find(lookup);
            var reportId = cbx.attr("reportid") + (cbx.attr("isadhoc")=='true' ? 1 : 0);

            if (reportId) {
                if (breakOnFirst) {
                    hidden.value = reportId;
                    return true;
                }
                else {
                    hidden.value += ((hidden.value != "") ? "|" : "") + reportId;
                }
            }
        });
    }
}